import React from 'react';
import BlogLayout from '../Blog/BlogLayout';

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 36 }}>
      <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 22, color: '#0E1430', marginBottom: 12, letterSpacing: '-0.02em' }}>{title}</h2>
      <div style={{ fontSize: 16, lineHeight: 1.75, color: '#3B4266' }}>{children}</div>
    </section>
  );
}

export default function Privacidade() {
  return (
    <BlogLayout title="Política de Privacidade" description="Saiba como o Integra MKP coleta, usa e protege seus dados pessoais, em conformidade com a LGPD.">
      <div style={{ maxWidth: 780, margin: '0 auto', padding: '64px 24px 100px' }}>
        <h1 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 900, fontSize: 40, letterSpacing: '-0.03em', color: '#0E1430', marginBottom: 8 }}>Política de Privacidade</h1>
        <div style={{ width: 60, height: 4, background: 'linear-gradient(90deg, #FFD400, #E63946, #2E7DE0)', borderRadius: 2, marginBottom: 12 }} />
        <p style={{ fontSize: 13, color: '#9CA3AF', marginBottom: 48 }}>Última atualização: abril de 2026</p>

        <Section title="1. Quem somos">
          <p>O <strong>Integra MKP</strong> é um serviço de dashboard para vendedores do Mercado Livre, operado por pessoa jurídica brasileira. Contato: <a href="mailto:integra.mplace@gmail.com" style={{ color: '#1B2A7A' }}>integra.mplace@gmail.com</a>.</p>
        </Section>

        <Section title="2. Dados que coletamos">
          <ul style={{ paddingLeft: 22 }}>
            <li style={{ marginBottom: 8 }}><strong>Cadastro:</strong> nome, e-mail e telefone fornecidos no momento do registro.</li>
            <li style={{ marginBottom: 8 }}><strong>Integração com Mercado Livre:</strong> token OAuth para acesso à sua conta ML — usamos apenas para exibir seus dados de pedidos, produtos e vendas dentro da plataforma.</li>
            <li style={{ marginBottom: 8 }}><strong>Pagamento:</strong> não armazenamos dados de cartão. Pagamentos são processados pelo Mercado Pago.</li>
            <li style={{ marginBottom: 8 }}><strong>Dados de uso:</strong> logs de acesso e erros para fins de segurança e melhoria do serviço.</li>
          </ul>
        </Section>

        <Section title="3. Como usamos seus dados">
          <ul style={{ paddingLeft: 22 }}>
            <li style={{ marginBottom: 8 }}>Autenticar seu acesso e manter sua sessão ativa.</li>
            <li style={{ marginBottom: 8 }}>Exibir informações da sua loja do Mercado Livre no dashboard.</li>
            <li style={{ marginBottom: 8 }}>Enviar notificações transacionais por e-mail (confirmação de cadastro, faturas).</li>
            <li style={{ marginBottom: 8 }}>Verificar identidade por SMS no cadastro.</li>
          </ul>
        </Section>

        <Section title="4. Compartilhamento de dados">
          <p>Não vendemos nem compartilhamos seus dados pessoais com terceiros, exceto:</p>
          <ul style={{ paddingLeft: 22, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>Mercado Pago — para processamento de pagamentos.</li>
            <li style={{ marginBottom: 8 }}>Brevo (Sendinblue) — para envio de e-mails e SMS transacionais.</li>
            <li style={{ marginBottom: 8 }}>Cloudflare — infraestrutura de hospedagem, sujeita à política de privacidade da Cloudflare.</li>
          </ul>
        </Section>

        <Section title="5. Segurança">
          <p>Os tokens de acesso ao Mercado Livre são armazenados com criptografia AES-256-GCM. Senhas são armazenadas com hash SHA-256 + salt. Utilizamos HTTPS em todas as comunicações.</p>
        </Section>

        <Section title="6. Seus direitos (LGPD)">
          <p>Conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você tem direito a:</p>
          <ul style={{ paddingLeft: 22, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>Confirmar a existência de tratamento dos seus dados.</li>
            <li style={{ marginBottom: 8 }}>Acessar, corrigir ou excluir seus dados pessoais.</li>
            <li style={{ marginBottom: 8 }}>Revogar o consentimento a qualquer momento.</li>
            <li style={{ marginBottom: 8 }}>Portabilidade dos dados.</li>
          </ul>
          <p style={{ marginTop: 12 }}>Para exercer qualquer desses direitos, envie um e-mail para <a href="mailto:integra.mplace@gmail.com" style={{ color: '#1B2A7A', fontWeight: 600 }}>integra.mplace@gmail.com</a>.</p>
        </Section>

        <Section title="7. Retenção de dados">
          <p>Mantemos seus dados enquanto a conta estiver ativa. Após o cancelamento, os dados são removidos em até 90 dias, exceto quando exigida retenção por obrigação legal.</p>
        </Section>

        <Section title="8. Cookies">
          <p>O Integra MKP não utiliza cookies de rastreamento ou publicidade. Utilizamos apenas o armazenamento local do navegador (localStorage) para manter sua sessão autenticada.</p>
        </Section>

        <Section title="9. Alterações nesta política">
          <p>Podemos atualizar esta política periodicamente. Notificaremos usuários por e-mail em caso de mudanças relevantes.</p>
        </Section>

        <Section title="10. Contato">
          <p>Dúvidas sobre privacidade: <a href="mailto:integra.mplace@gmail.com" style={{ color: '#1B2A7A', fontWeight: 600 }}>integra.mplace@gmail.com</a></p>
        </Section>
      </div>
    </BlogLayout>
  );
}
